export const asChatBubble = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M13.66 1.666c0-.733-.593-1.333-1.326-1.333H1.667C.933.333.333.933.333 1.666v8C.333 10.4.933 11 1.667 11H11l2.667 2.666-.007-12Zm-1.326 0v8.78l-.78-.78H1.666v-8h10.667ZM3 7h8v1.333H3V7Zm0-2h8v1.333H3V5Zm0-2h8v1.333H3V3Z" fill="#818F99"/>
  </svg>`,
  name: 'chatBubble',
};
